/**
 * 
 * Verification
 * 
 */


import React,{useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import styles from './styles';
import Button from '@material-ui/core/Button';
import LockIcon from '@material-ui/icons/Lock';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import withQueryParams from 'react-router-query-params';
import { compose } from 'redux';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';

function Verification({ handleVerify, error, sendOtp, resendCount, style, queryParams = {}, clientRecord, otpSent }) {
    const { TargetLanguageCode } = queryParams;
    const classes = styles();
    const [securityCode, setSecurityCode] = React.useState("");
    // const [otpSent, setOtpSent] = useState(false);

    const onChange = (e) => {
        setSecurityCode(e.target.value);
    }
    const phoneNumber = clientRecord && clientRecord?.phone
    const lastFourDigits = phoneNumber && phoneNumber.slice(-4);

  const ClipWrapper = styled.div`
  text-align: center;
`;

  if (!clientRecord) {
    return <div style={{width:'100%',height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
    <ClipWrapper>
      <ClipLoader color={"#2ca01c"} />
    </ClipWrapper>
    </div>
  }

    return (
        <Grid
            container
            spacing={0}
            align="center"
            justify="center"
            direction="column"
            style={style}
            className={classes.grid}
        >
            {otpSent && <Grid item >
                <LockIcon className={classes.lockIcon} style={{ height: '60px' }} />
                <Typography variant="h1" gutterBottom className={classes.twoStep}>{TargetLanguageCode === 'es' ? 'Verificación de dos pasos' : TargetLanguageCode === 'vi' ? 'Xác minh hai bước' : TargetLanguageCode === 'cmn' ? `两步验证` : 'Two Step Verification'}</Typography>
                <Typography className={classes.instructions} dangerouslySetInnerHTML={{ __html: TargetLanguageCode === 'es' ? `Para mantener sus datos seguros, necesitamos verificar su identidad. <br /> ¡Gracias por su comprensión!` : TargetLanguageCode === 'vi' ? 'Để giữ an toàn cho dữ liệu của bạn, chúng tôi cần xác minh danh tính của bạn. <br /> Cảm ơn bạn đã thông cảm!' : TargetLanguageCode === 'cmn' ? `为了确保您的数据安全，我们需要验证您的身份。<br /> 感谢您的理解！` : 'In order to keep your data safe we need to verify your identity. <br /> Thank you for your understanding!' }} />

                {error ? <Typography className={classes.errorMessage}>{error}</Typography> : <Typography className={classes.textMessage}>{TargetLanguageCode === 'es' ? 'Se ha enviado un mensaje de texto con un código secreto a su teléfono móvil' : TargetLanguageCode === 'vi' ? 'Một tin nhắn văn bản với mã bí mật đã được gửi đến điện thoại di động của bạn' : TargetLanguageCode === 'cmn' ? `一条带有密码的短信已发送至您的手机` : 'A text message with secret code has been sent to your mobile phone'}</Typography>}

                <TextField id="filled-basic" label="" variant="filled" className={classes.fieldColor}
                    onChange={onChange}
                    inputProps={{ min: 0, style: { textAlign: 'center', fontSize: '22px' } }}
                />
                <Grid item>
                    {securityCode !== '' ? <Button className={classes.btnVerify}
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => handleVerify(securityCode)}>
                        {TargetLanguageCode === 'es' ? 'Verificar' : TargetLanguageCode === 'vi' ? 'Xác nhận' : TargetLanguageCode === 'cmn' ? `核实` : 'Verify'}
                    </Button> : <Button className={classes.btnVerifyDisabled}
                            type="button"
                            variant="contained"
                            color="primary">
                            {TargetLanguageCode === 'es' ? 'Verificar' : TargetLanguageCode === 'vi' ? 'Xác nhận' : TargetLanguageCode === 'cmn' ? `核实` : 'Verify'}
                    </Button>}

                </Grid>

                {resendCount < 2 ? <Grid item xs>
                    <Button className={classes.linkColor}
                        type="button"
                        variant="contained"
                        onClick={sendOtp}
                        color="primary">
                        {TargetLanguageCode === 'es' ? 'Reenviar OTP' : TargetLanguageCode === 'vi' ? 'Gửi lại OTP' : TargetLanguageCode === 'cmn' ? `重新发送 OTP` : 'Resend OTP'}
                    </Button>
                </Grid> : null}
            </Grid> ||

          
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="80vh"
            textAlign="center"
          >
             <LockIcon className={classes.lockIcon} style={{ height: '60px', marginBottom: 24 }} />
            <Typography variant="h5" gutterBottom>
            {TargetLanguageCode === 'es' ? 'ENVIAR OTP' : TargetLanguageCode === 'vi' ? 'Gửi OTP' : TargetLanguageCode === 'cmn' ? `发送 OTP` : 'SENT OTP'}
            </Typography>

            {/* <Typography variant="h5" gutterBottom>
              Welcome to the Client Portal
            </Typography> */}
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            {TargetLanguageCode === 'es' ? 'El acceso seguro comienza aquí' : TargetLanguageCode === 'vi' ? 'Truy cập an toàn bắt đầu từ đây' : TargetLanguageCode === 'cmn' ? `安全访问从这里开始` : 'Secure access starts here'}
            </Typography>
      
            <Typography variant="body1" color="textSecondary" gutterBottom>
            {TargetLanguageCode === 'es' ? 'Le enviaremos un OTP a su número de móvil que termina en' : TargetLanguageCode === 'vi' ? 'Chúng tôi sẽ gửi OTP đến số điện thoại di động của bạn kết thúc bằng' : TargetLanguageCode === 'cmn' ? `我们将向您的手机号码发送一个 OTP，尾号为` : 'We will send an OTP to your mobile number ending in'} XXX-XXX-{lastFourDigits}.
            </Typography>
            <Button variant="contained" color="primary" style={{fontWeight:'bold',marginTop:'20px'}} onClick={(e)=>{
                 sendOtp()
                }}>
             {TargetLanguageCode === 'es' ? 'Enviar OTP' : TargetLanguageCode === 'vi' ? 'Gửi OTP' : TargetLanguageCode === 'cmn' ? `发送OTP` : 'Send OTP'}
            </Button>
          </Box>}
        </Grid> 
       
    )

    
    
}

export default compose(
    withQueryParams()
)(Verification);